(() => {
    function setupDisclosures() {
        const disclosures = Array.from(document.querySelectorAll('details[data-sb-menu], details[data-sb-country-popover]'));
        const hover = window.matchMedia('(hover: hover) and (min-width: 901px)');
        const openedByHover = new WeakSet();
        const close = (disclosure) => {
            disclosure.open = false;
            openedByHover.delete(disclosure);
        };
        const closeOthers = (current) => disclosures.forEach((disclosure) => {
            if (disclosure !== current) close(disclosure);
        });

        disclosures.forEach((disclosure) => {
            const summary = disclosure.querySelector(':scope > summary');
            if (!summary) return;
            summary.addEventListener('click', (event) => {
                if (event.detail > 0 && disclosure.open && openedByHover.has(disclosure)) {
                    // The first pointer click confirms a menu that hover already opened.
                    event.preventDefault();
                    openedByHover.delete(disclosure);
                }
                if (!disclosure.open || openedByHover.has(disclosure)) closeOthers(disclosure);
            });
            disclosure.addEventListener('toggle', () => {
                if (disclosure.open) closeOthers(disclosure);
                else openedByHover.delete(disclosure);
            });
            if (!disclosure.hasAttribute('data-sb-menu')) return;
            disclosure.addEventListener('pointerenter', (event) => {
                if (!hover.matches || event.pointerType === 'touch' || disclosure.open) return;
                closeOthers(disclosure);
                openedByHover.add(disclosure);
                disclosure.open = true;
            });
            disclosure.addEventListener('pointerleave', () => {
                if (hover.matches && !disclosure.contains(document.activeElement)) close(disclosure);
            });
        });

        document.addEventListener('click', (event) => {
            disclosures.forEach((disclosure) => {
                if (!disclosure.contains(event.target)) close(disclosure);
            });
        });
        document.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape') return;
            const current = disclosures.find((disclosure) => disclosure.open && disclosure.contains(event.target)) ||
                disclosures.find((disclosure) => disclosure.open);
            if (!current) return;
            event.preventDefault();
            close(current);
            current.querySelector(':scope > summary')?.focus();
        });
    }

    function setupMobileNavigation() {
        const mobile = window.matchMedia('(max-width: 900px)');
        document.querySelectorAll('[data-sb-mobile-navigation]').forEach((wrapper) => {
            const button = wrapper.querySelector('[data-sb-mobile-menu-toggle]');
            const label = button?.querySelector('[data-sb-mobile-menu-label]');
            const navigation = wrapper.querySelector('.sb-shop-nav');
            if (!button || !label || !navigation) return;

            const setOpen = (open) => {
                navigation.hidden = mobile.matches && !open;
                button.setAttribute('aria-expanded', String(mobile.matches && open));
                label.textContent = mobile.matches && open ? 'Close menu' : 'Menu';
                if (mobile.matches && !open) navigation.querySelectorAll('details[open]').forEach((disclosure) => disclosure.open = false);
            };
            const updateLayout = () => {
                const focused = document.activeElement;
                button.hidden = !mobile.matches;
                setOpen(false);
                if (mobile.matches && navigation.contains(focused)) button.focus();
                else if (!mobile.matches && focused === button) navigation.querySelector('a, summary')?.focus();
            };

            button.addEventListener('click', () => setOpen(navigation.hidden));
            document.addEventListener('click', (event) => {
                if (mobile.matches && !navigation.hidden && !wrapper.contains(event.target)) setOpen(false);
            });
            document.addEventListener('keydown', (event) => {
                if (event.key !== 'Escape' || event.defaultPrevented || !mobile.matches || navigation.hidden ||
                    !wrapper.contains(event.target)) return;
                event.preventDefault();
                setOpen(false);
                button.focus();
            });
            mobile.addEventListener('change', updateLayout);
            updateLayout();
        });
    }

    function loadBestSellers() {
        const host = document.querySelector('[data-sb-bestsellers][data-collection-url]');
        const content = host?.querySelector('[data-sb-bestseller-content]');
        if (!content) return;
        const fallback = () => {
            const status = content.querySelector('[role="status"]') || document.createElement('p');
            status.textContent = 'Use the link above to browse books by sales rank.';
            if (!status.parentNode) content.append(status);
        };
        let url;
        try {
            if (host.dataset.rankField !== 'salesrank_combined_v1') {
                fallback();
                return;
            }
            url = new URL(host.dataset.collectionUrl, window.location.href);
            if (url.origin !== window.location.origin || url.username || url.password) {
                fallback();
                return;
            }
            url.searchParams.set('sort_by', 'manual');
            url.searchParams.set('section_id', 'sb-best-sellers');
            url.searchParams.set('page', '1');
            const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
            if (preview !== null) url.searchParams.set('preview_theme_id', preview);
        } catch {
            fallback();
            return;
        }

        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 5000);
        fetch(url, {signal: controller.signal, credentials: 'same-origin', redirect: 'error'})
            .then((response) => {
                if (!response.ok) throw new Error('Shelf could not be loaded.');
                return response.text();
            })
            .then((html) => {
                // A template stays inert while parsing: scripts and images cannot run here.
                const template = document.createElement('template');
                template.innerHTML = html;
                const ranked = template.content.querySelector('[data-sb-bestseller-content][data-sb-ranked]');
                if (!ranked || ranked.dataset.sbRanked !== host.dataset.rankField) throw new Error('Ranked shelf is missing.');
                ranked.querySelectorAll('script, style, iframe, object, embed, base, meta, link').forEach((element) => element.remove());
                ranked.querySelectorAll('*').forEach((element) => {
                    Array.from(element.attributes).forEach((attribute) => {
                        const activeUrl = ['href', 'src', 'xlink:href', 'action', 'formaction'].includes(attribute.name) &&
                            /^(javascript|vbscript|data):/i.test(attribute.value.replace(/[\u0000-\u0020]/g, ''));
                        if (attribute.name.startsWith('on') || activeUrl) element.removeAttribute(attribute.name);
                    });
                });
                const products = ranked.querySelector('.sb-home-products');
                if (!products || products.children.length === 0) throw new Error('Ranked shelf is empty.');
                content.replaceChildren(...ranked.childNodes);
                content.dataset.sbRanked = host.dataset.rankField;
            })
            .catch(fallback)
            .finally(() => window.clearTimeout(timeout));
    }

    function start() {
        if (document.querySelector('[data-sb-legacy-bestsellers]')) {
            const url = new URL(window.location.href);
            if (!url.searchParams.has('sort_by') || url.searchParams.get('sort_by') === 'best-selling') {
                url.searchParams.set('sort_by', 'manual');
                window.location.replace(url.href);
                return;
            }
        }
        setupDisclosures();
        setupMobileNavigation();
        document.querySelectorAll('form.sb-country-form').forEach((form) => {
            form.addEventListener('submit', () => {
                const destination = form.elements.namedItem('return_to');
                if (destination) {
                    const anchor = form.dataset.sbReturnAnchor === 'drop-off-locations' ? '#drop-off-locations' : '';
                    destination.value = window.location.pathname + window.location.search + anchor;
                }
            });
        });
        loadBestSellers();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
    else start();
})();
